import { render, staticRenderFns } from "./RegisterHow.vue?vue&type=template&id=8da3303a&"
import script from "./RegisterHow.vue?vue&type=script&lang=js&"
export * from "./RegisterHow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports